// extracted by mini-css-extract-plugin
export default {"tableRoot":"CodeReviewTable_tableRoot__F1y16","tableCell":"CodeReviewTable_tableCell__n9qOH","linksContainer":"CodeReviewTable_linksContainer__A6UkI"};